'use strict';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
  const testimonialsSections = document.querySelectorAll('.rc-testimonials');

  if (testimonialsSections.length) {
    testimonialsSections.forEach((section) => {
      const swiperEl = section.querySelector('.swiper');

      const swiper = new Swiper(swiperEl, {
        modules: [Navigation],
        slidesPerView: 1,
        loop: true,
        speed: 400,

        navigation: {
          nextEl: '.rc-testimonials__button-next',
          prevEl: '.rc-testimonials__button-prev',
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1025: {
            slidesPerView: 3,
          },
        },
      });
    });
  }

  // Get the header-search container
  const searchContainer = document.querySelector('.header-search');

  if (searchContainer) {
    // Get the search input and search button elements within the container
    const searchInput = searchContainer.querySelector('.e-search-input');
    const searchButton = searchContainer.querySelector('.e-search-submit');

    // Function to check if input is empty and disable/enable the button
    function checkInput() {
      if (searchInput.value.trim() === '') {
        searchButton.disabled = true;
      } else {
        searchButton.disabled = false;
      }
    }

    // Run the check on page load
    checkInput();

    // Add event listener to the input field to check on every input change
    searchInput.addEventListener('input', checkInput);
  }

  // forms select logic ========================================================
  const formSelects = document.querySelectorAll(
    '.ro-form-section .frm_form_field select'
  );
  if (formSelects) {
    formSelects.forEach((select) => {
      select.addEventListener('change', function () {
        const select = this;
        if (select.value === '') {
          select.classList.remove('has-value');
        } else {
          select.classList.add('has-value');
        }
      });
    });
  }
});
